export default "__VITE_ASSET__C8OV$Du0__"